import { apiSlice } from './apiSlice';

export const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContactSupport: builder.query<
      {
        whatsapp: string | null;
        telegram: string | null;
      } | null,
      void
    >({
      query: () => ({
        url: '/contact-support',
        method: 'GET',
        params: { t: Date.now() },
      }),
    }),
  }),
});

export const { useGetContactSupportQuery } = notificationApi;
